export const spacing = {
  'spacing-0': '0px',
  'spacing-1': '2px',
  'spacing-2': '4px',
  'spacing-3': '8px',
  'spacing-4': '12px',
  'spacing-5': '16px',
  'spacing-6': '24px',
  'spacing-7': '32px',
  'spacing-8': '40px',
  'spacing-9': '48px',
  'spacing-10': '56px',
  'spacing-11': '64px',
  'spacing-12': '72px',
  'spacing-13': '80px',
};
